import React from 'react';
import { polosGeradoresColor } from '../../util/colors';

/**
 * Legenda flutuante dos polos geradores agrupados — versão React do
 * `ClusterService.addLegenda` do mapa Google (que monta o mesmo box em DOM imperativo e o
 * empurra para `map.controls[BOTTOM_CENTER]`, API que o MapBox não tem).
 *
 * Lista apenas as categorias que estão de fato no mapa, cada uma com a cor do seu cluster e
 * a escala de intensidade por contagem (5 / 50 / 100+), espelhando o `0.4 + intensity * 0.6`
 * usado no `circle-color` das camadas de cluster de polos.
 *
 * @param {{categorias: string[], sidebarAberta: boolean}} props
 */
const LegendaGradientePolos = ({ categorias, sidebarAberta }) => {
    const visiveis = categorias
        .filter((categoria) => polosGeradoresColor[categoria])
        .sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));

    if (visiveis.length === 0) {
        return null;
    }

    return (
        <div className={`mapbox-polos-legend${sidebarAberta ? ' is-sidebar-open' : ''}`}>
            {visiveis.map((categoria) => {
                const [r, g, b] = polosGeradoresColor[categoria];
                const rgba = (opacidade) => `rgba(${r}, ${g}, ${b}, ${opacidade})`;

                return (
                    <div key={categoria} className="mapbox-polos-legend-item">
                        <strong>{categoria}:</strong>
                        <span
                            className="mapbox-polos-legend-bar"
                            style={{ background: `linear-gradient(to right, ${rgba(0.4)}, ${rgba(1)})` }}
                        />
                        <div className="mapbox-polos-legend-scale">
                            <span style={{ background: rgba(0.4) }}>5</span>
                            <span style={{ background: rgba(0.7) }}>50</span>
                            <span style={{ background: rgba(1) }}>100+</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default LegendaGradientePolos;
